import classNames from "classnames";
import React, { Component } from "react";
import "./stepper.style.scss";

export default class Stepper extends Component {
  render() {
    return (
      <div className="stepper-container">
        {this.props.steps.map((step, index) => (
          <div className="step-item-container">
            <div
              className={classNames("step-item", {
                "step-active": this.props.activeStep === index + 1,
                "step-completed": this.props.activeStep > index + 1,
              })}
            >
              <div className="step-index">
                {this.props.activeStep > index + 1 ? "✓" : index + 1}
              </div>
              <div className="step-title">
                {step.title}
                <div className="step-desc">{step.description}</div>
              </div>
            </div>
            {index < this.props.steps.length - 1 && (
              <div
                className={classNames("step-connector", {
                  "step-connector--done": this.props.activeStep > index + 1,
                })}
              ></div>
            )}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/Stepper/Stepper.js